<div class="size-swatch">
    @if (filterValues(); as filterValuesArray) { @for (filterValue of filterValuesArray; track
    filterValue) {
    <base-checkbox-filter [isChecked]="filterValue?.checked || false" [type]="type() || 'checkbox'" (checked)="selectFilter(filterValue)" [label]="filterValue?.value || ''" [doc_count]="filterValue?.doc_count || 0">
    </base-checkbox-filter>
    } }
</div>